// /home/szymon/kreator2/frontend/src/components/editor/EditorPersonalizePanel.js
// v1.4.0 - Dostosowanie do nowego hooka: obsługa ładowania, poprawny zapis przy przejściu

import React, { useRef, useState, useEffect } from "react";
import { LayoutDashboard } from 'lucide-react'; // Import ikony z lucide-react

export default function EditorPersonalizePanel({
  personalizationText,
  setPersonalizationText,
  // onManualSave, // Usunięto stary prop
  handleManualSaveLocal, // NOWY prop z hooka do zapisu historii
  isLoadingGuests, // NOWY prop z hooka wskazujący na ładowanie
  onGoBack, // Funkcja do przejścia do panelu zamówienia
  tooltipsEnabled // Flaga określająca, czy podpowiedzi są włączone
}) {
  // Rozbijamy tekst na linie:
  const lines = personalizationText.split("\n");

  // Referencje do kontenerów, aby móc zsynch. scroll
  const lineNumbersRef = useRef(null);
  const textareaRef = useRef(null);

  // Obsługa przewijania: gdy textarea się przewija, przesuwamy numery linii
  const handleTextScroll = (e) => {
    if (lineNumbersRef.current) {
      lineNumbersRef.current.scrollTop = e.target.scrollTop;
    }
  };

  // Funkcja do przewijania na dół po zmianie tekstu
  const scrollToBottom = () => {
    if (textareaRef.current) {
      textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
      if (lineNumbersRef.current) {
        lineNumbersRef.current.scrollTop = lineNumbersRef.current.scrollHeight;
      }
    }
  };

  // Efekt, który przewija na dół po wklejeniu długiej listy
  useEffect(() => {
    if (textareaRef.current &&
        textareaRef.current.scrollHeight > textareaRef.current.clientHeight) {
      scrollToBottom();
    }
  }, [personalizationText]);

  return (
    <div style={{ padding: 16 }}>
      <h3 style={{ marginBottom: 12 }}>Lista gości (personalizacja)</h3>

      {/* Kontener edytora listy gości */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "50px 1fr",
          gap: "8px",
          maxHeight: "350px",
          overflow: "auto",
          border: "1px solid #ccc",
          borderRadius: 4,
          position: "relative" // Potrzebne do pozycjonowania overlay'a ładowania
        }}
      >
        {/* --- NOWOŚĆ: Overlay ładowania --- */}
        {isLoadingGuests && (
          <div style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10,
            borderRadius: 4
          }}>
            <p style={{ color: "#333", fontWeight: "bold" }}>Ładowanie listy gości...</p>
          </div>
        )}

        {/* Numery wierszy */}
        <div
          ref={lineNumbersRef}
          style={{
            overflowY: "auto",
            height: "100%",
            fontFamily: "monospace",
            fontSize: "14px",
            lineHeight: "1.4em",
            textAlign: "right",
            padding: "8px 4px",
            boxSizing: "border-box",
            backgroundColor: "#fafafa",
            borderRight: "1px solid #ccc",
            opacity: isLoadingGuests ? 0.5 : 1 // Przyciemnij podczas ładowania
          }}
        >
          {lines.map((_, idx) => (
            <div
              key={idx}
              style={{
                lineHeight: "1.4em"
              }}
            >
              {idx + 1}
            </div>
          ))}
        </div>

        {/* Pole tekstowe z gośćmi */}
        <textarea
          ref={textareaRef}
          value={personalizationText}
          onChange={(e) => {
            setPersonalizationText(e.target.value);
          }}
          onScroll={handleTextScroll}
          style={{
            overflowY: "auto",
            height: "100%",
            fontFamily: "monospace",
            fontSize: "14px",
            lineHeight: "1.4em",
            padding: "8px",
            boxSizing: "border-box",
            border: "none",
            outline: "none",
            resize: "none",
            backgroundColor: "transparent",
            opacity: isLoadingGuests ? 0.5 : 1 // Przyciemnij podczas ładowania
          }}
          placeholder="Wpisz lub wklej po jednym gościu w każdym wierszu..."
          disabled={isLoadingGuests} // Wyłącz edycję podczas ładowania
        />
      </div>

      <p style={{ fontSize: 12, color: "#666", marginTop: 8 }}>
        Zmiany zapiszą się automatycznie lub przyciskiem „Zapisz" w górnym pasku.
      </p>

      {/* Sekcja z informacją i przyciskiem do panelu zamówienia */}
      <div style={{
        marginTop: 24,
        padding: 16,
        backgroundColor: "#f8f9fa",
        borderRadius: 8,
        border: "1px solid #e2e8f0"
      }}>
        <p style={{ fontSize: 14, color: "#4a5568", marginBottom: 16, lineHeight: "1.5" }}>
          Aby zobaczyć projekt z podstawionymi nazwiskami gości, przejdź do panelu zamówienia.
        </p>

        {/* Przycisk "Panel zamówienia" */}
        <button
          onClick={() => {
            // --- ZMIANA: Wywołaj handleManualSaveLocal przed przejściem ---
            if (handleManualSaveLocal) {
              console.log("[EditorPersonalizePanel] Calling handleManualSaveLocal before navigating...");
              handleManualSaveLocal(); // Zapisz aktualną listę gości do historii
            } else {
              console.warn("[EditorPersonalizePanel] handleManualSaveLocal is not defined!");
            }
            // Przejdź do panelu zamówienia
            if (onGoBack) {
              onGoBack();
            }
          }}
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "8px 16px",
            backgroundColor: "#4299e1",
            color: "#ffffff",
            border: "1px solid #4299e1",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: 500,
            cursor: "pointer",
            transition: "all 0.2s ease-in-out",
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#2b6cb0"}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#4299e1"}
          data-tooltip-id={tooltipsEnabled ? "editor-tooltip" : undefined}
          data-tooltip-content={tooltipsEnabled ? "Zapisz zmiany i przejdź do panelu zamówienia, aby zobaczyć projekt z podstawionymi nazwiskami gości." : undefined}
          disabled={isLoadingGuests} // Wyłącz przycisk podczas ładowania
        >
          <LayoutDashboard size={20} style={{ marginRight: "4px" }} />
          Panel zamówienia
        </button>
      </div>
    </div>
  );
}
